import React from "react";

export default class CloseIcon extends React.PureComponent {
    render() {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 12 12"
                {...this.props}
            >
                <g>
                    <path d="M12,1.212,10.788,0,6,4.788,1.212,0,0,1.212,4.788,6,0,10.788,1.212,12,6,7.212,10.788,12,12,10.788,7.212,6Z" />
                </g>
            </svg>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/CloseIcon.js